<template>
  <div>
    <div class="row">
      <div
        class="col-md-6 col-lg-4 col-xl-4"
        v-for="stat in stats"
        :key="stat.title"
      >
        <stats-card>
          <div
            class="icon-big text-center text-warning"
            :class="`icon-${stat.type}`"
            slot="header"
          >
            <i :class="stat.icon"></i>
          </div>
          <div class="numbers" slot="content">
            <p>{{ stat.key | setText(stat.title) }}</p>
            {{ stat.value | price }}
          </div>
        </stats-card>
      </div>
    </div>

    <div>
      <!-- <calendar-custom /> -->
      <calendar-timetable v-if="business" />
    </div>
  </div>
</template>
<script>
import { StatsCard, ChartCard } from "@/components/index";


import { errorNotify } from "@/plugins/functions";

import { mapState } from "vuex";
import CalendarTimetable from "../components/CalendarTimetable";
export default {
  components: {
    StatsCard,
    ChartCard,

    CalendarTimetable,
  },
  created() {
    this.refresh();
  },
  methods: {
    refresh() {
      if (this.$store.state.root) {
        this.$loading(true);
        this.$http
          .get(`${this.$store.state.root ? "" : "business/"}stats`)
          .then((response) => {
            this.stats = response.data.data;
          })
          .catch((error) => {
            errorNotify(error, this.$notify);
          })
          .finally(() => {
            setTimeout(() => {
              this.$loading(false);
            }, 200);
          });
      } else {
      }
    },
  },
  data() {
    return {
      stats: [],
      date: null,
    };
  },
  computed: {
    ...mapState(["user", "business"]),
  },
};
</script>
